import React from 'react'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import { useTranslation } from 'react-i18next'
import { TableHeader, DataMessage } from '..'
import CouponCategoryTableRow from './CouponCategoryTableRow'
import { makeStyles } from '@material-ui/core/styles'
import { useStore } from '../../Models/RootStore'

const useStyles = makeStyles((theme) => ({
	root: {
		maxWidth: 1400
	},
	smallSpacer: {
		height: '0.25rem'
	},
	spacer: {
		height: '1rem'
	}
}))

function CouponCategoryTable(props) {
	const classes = useStyles()
	const { t } = useTranslation()

	const { sessionStore } = useStore()

	const filteredItems = sessionStore.user.role === 'admin' ? props.items : props.items?.filter((item) => item.creatorId === sessionStore.user.id) || []

	const renderRows = () => {
		if (filteredItems.length > 0) {
			return filteredItems.map((item) => (
				<React.Fragment key={item.id}>
					<div className={classes.spacer} />
					<CouponCategoryTableRow item={item} />
				</React.Fragment>
			))
		}
		return null
	}

	return (
		<>
			<Table classes={{ root: classes.root }}>
				<TableHeader columnNames={[t('name_fi'), t('name_en')]} />
				<div className={classes.smallSpacer} />
				<TableBody>{renderRows()}</TableBody>
			</Table>
			<DataMessage data={filteredItems} message={t('no_items')} />
		</>
	)
}

export default CouponCategoryTable
